export default __webpack_public_path__ + "static/media/blueApproved.c6f8b65a.svg";